import { render, staticRenderFns } from "./u-btn-arrow-outlined-rounded.vue?vue&type=template&id=d890dbc8&scoped=true&"
import script from "./u-btn-arrow-outlined-rounded.vue?vue&type=script&lang=js&"
export * from "./u-btn-arrow-outlined-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d890dbc8",
  null
  
)

export default component.exports